





































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import {
  DiamondSupportListClient,
  DistributorModel,
  DistributorsClient,
  DsListEntryModel,
} from "@/diamond-support-api";
import {
  AssociateDataHelper,
  DiamondDataHelper,
  AssociateData,
  DiamondData,
} from "@/Helpers/DistributorDataHelper";

@Component
export default class AssociateDetail extends Vue {
  @Action("saveDiamondList", { namespace: "diamond" }) saveDiamondList: any;

  distributorDetail: DistributorModel | null = null;
  distributorApi = new DistributorsClient();

  associateDataHelper = new AssociateDataHelper();
  diamondDataHelper = new DiamondDataHelper();
  associateDetail: AssociateData | null = null;
  diamondApi = new DiamondSupportListClient();

  diamondListItemSPA: DiamondData | null = null;
  diamondListItem: DsListEntryModel | null = null;

  loading = false;

  async mounted() {
    await this.loadItem();
  }

  @Watch("$route.params.id")
  async onItemChanged(val: string | null, oldVal: string | null) {
    if (!val) return;
    await this.loadItem();
  }

  async loadItem() {
    this.loading = true;
    await this.distributorApi
      .get(this.$route.params.id)
      .then((response: DistributorModel) => {
        if (response && response.distributorId) {
          this.loading = false;
          this.distributorDetail = response;
          this.associateDetail = this.associateDataHelper.getAssociateDetail(
            this.distributorDetail
          );
          this.diamondListItemSPA = this.diamondDataHelper.getDiamondList(
            this.distributorDetail
          );
          this.diamondListItem = <DsListEntryModel>this.diamondListItemSPA;
          //generate diamondlist data from 'distributor get' and save that into SPA
          this.saveDiamondList(this.diamondListItemSPA);
          //check if this diamond info is saved in the database already.  If that is the case, update the info using diamondApi post.
          //If that is not save yet, let user decide on the diamond list page
          this.checkDiamondInfoNUpdate(this.diamondListItem);
        }
      })
      .catch((error: any) => {
        console.log("error", error);
        this.loading = false;
      });
  }

  showEnrollments() {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/associatePersonalEnrollments`,
    });
  }
  showNotesList(distributorDetail: DistributorModel) {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/notesList`,
    });
  }
  addNote() {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/noteAdd`,
    });
  }
  addReminder() {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/reminderAdd`,
    });
  }
  showRankHistory() {
    this.$router.push({
      path: `/associates/${this.$route.params.id}/detail/rankHistory`,
    });
  }

  showCommissionHistory() {
    this.$router.push({
      path: `/DSPlus/${this.$route.params.id}`,
    });
  }

  async checkDiamondInfoNUpdate(diamondListItem: DsListEntryModel) {
    await this.diamondApi
      .index()
      .then((response) => {
        if (
          response.find((x) => x.distributorId == diamondListItem.distributorId)
        ) {
          this.saveDiamondInfoToDB(diamondListItem);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
    async saveDiamondInfoToDB(item: DsListEntryModel) {
    await this.diamondApi.post(item).catch((error: any) => {
      console.log("error", error);
    });
  }
}
